module.exports = __webpack_public_path__ + "img/productDetailPage.392bdb5d.jpg";